import { Navigate } from "react-router-dom"

const Rewards = () => {
  return <Navigate to="/dashboard" replace />
}

export default Rewards
